import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Button from 'common/button';
// import DigitalWallet from './digital-wallet';

const PaymentButtons = ({ disabled, onContinue }) => {
    return (
        <div className={cx({ 'pointer-events-none': disabled })}>
            {/* <DigitalWallet /> */}
            <Button
                size="md"
                onClick={onContinue}
                color={disabled ? 'light' : 'green'}
                className="text-16 font-medium block w-full"
            >
                Continue to payment
            </Button>
        </div>
    );
};

PaymentButtons.propTypes = {
    disabled: PropTypes.bool,
    onContinue: PropTypes.func.isRequired,
};

PaymentButtons.defaultProps = {
    disabled: false,
};

export default PaymentButtons;
